class PlayerProfileController {
  constructor(PlayersFactory, $rootScope, $stateParams, $filter, $state, URLS) {
    "ngInject";
    const vm = this;

    vm.rootScope = $rootScope;

    vm.state = $state;

    vm.$onInit = () => {
      vm.components = [
        { state: "player-profile.info", name: "INFORMATION" },
        { state: "player-profile.matches", name: "MATCHES" },
        {
          state: "player-profile.transfers",
          name: "TRANSFERS",
          permission: vm.rootScope.permissions.VIEW_ALL_TRANSFERS,
        },
        {
          state: "player-profile.payments",
          name: "PAYMENTS",
          permission: vm.rootScope.permissions.VIEW_ALL_MOVEMENTS_PLAYER,
        },
        { state: "player-profile.trainingEntries", name: "TRAINING_ENTRIES" },
        // {state: 'player-profile.passports', name: 'PASSPORTS'},
      ];
      vm.playerId = $stateParams.id;
      vm.player = {};
      if (vm.playerId) {
        PlayersFactory.getOne(vm.playerId, {
          include: "team,state,citizenship,nationality",
        }).then((response) => {
          vm.player = response.data;
        });
      }
      $state.go("player-profile.info");
    };

    vm.hasPermission = (permission) => {
      if (vm.rootScope.user.isUserTypeTeam()) {
        return (
          vm.rootScope.user.isTeam(vm.player.team_id) &&
          vm.rootScope.user.canDo(permission)
        );
      } else {
        return vm.rootScope.user.canDo(permission);
      }
    };

    vm.getPlayerImage = () => {
      if (vm.player.img) {
        return URLS.IMAGES_URL + "/players/" + vm.player.img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.getCard = () => {
      const tabWindowId = window.open("about:blank", "_blank");
      PlayersFactory.card(vm.player.player_id).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };

    vm.getPlayerHighestLevelClass = () => {
      if (vm.player.compound_level > vm.player.recurve_level) {
        return `level-indicator level-${vm.player.compound_level}`;
      }
      return `level-indicator level-${vm.player.recurve_level}`;
    };
  }
}

export default PlayerProfileController;



// WEBPACK FOOTER //
// ./client/app/components/players/playerProfile/playerProfile.controller.js